<template>
    <v-card color="inverseGrey" :height="dynamicVCardHeight" class="v-card-main text-center rounded-xl">

        <div class="v-card-container">
            <v-row no-gutters class="index-card-container">
                <div class="index-card front-card" :class="animationClass" @animationend="resetAnimation" :style="dynamicIndexCardWidthHeight">
                    <div class="left-zone" @click.stop="triggerAnimation('shuffle-to-front')"></div>
                    <div class="right-zone" @click.stop="triggerAnimation('shuffle-to-back')"></div>
                    <v-card-title :style="dynamicFontSizeFrontCard" class="justify-center mx-xl-10 mx-lg-10 font-weight-medium black--text">{{textPost.textAdded[textCardIndex]}}</v-card-title>
                </div>
                <div class="index-card back-card" :style="dynamicIndexCardWidthHeight">
                    <v-card-title v-if="shuffleToFrontFromMenu" :style="dynamicFontSizeBackCard" class="justify-center mx-xl-15 mx-lg-10 font-weight-medium black--text">{{textPost.textAdded[backTextCardIndex]}}</v-card-title>
                    <v-card-title v-else :style="dynamicFontSizeBackCard" class="justify-center mx-xl-15 mx-lg-10 font-weight-medium black--text">{{textPost.textAdded[textCardIndex+1]}}</v-card-title>
                </div>
            </v-row>
            <v-row no-gutters class="play-pause-button-container">

                <v-col cols="2" sm="1" md="1" lg="1" xl="1" class="ma-0 pa-0">
                    <v-btn v-if="currentSubtitle" large icon :color="audioIsLoading ? 'white' : 'black'" :ripple="false" :loading="audioIsLoading" :disabled="!currentSubtitle || isShuffling || audioIsLoading" style="z-index: 2; opacity: 0.75;" class="play-pause-button black" @click.stop="advancedControlsClick('playPauseReplay')">
                        <v-icon v-if="!audioIsPlaying && !currentSubtitle.hasBeenPlayed" x-large color="white">mdi-play</v-icon>
                        <v-icon v-else-if="audioIsPlaying && !currentSubtitle.hasBeenPlayed" x-large color="white">mdi-pause</v-icon>
                        <v-icon v-else large color="white">mdi-replay</v-icon>
                    </v-btn>
                    <v-btn v-else large icon disabled style="z-index: 2; opacity: 0.5;" class="play-pause-button black">
                        <v-icon x-large color="white">mdi-play</v-icon>
                    </v-btn>
                </v-col>

            </v-row>
            <v-row no-gutters class="captions-container">
                <v-card-text v-if="currentSubtitle && showCaptions" :style="dynamicFontSizeCurrentSubtitle">{{ currentSubtitle.subtitle }}</v-card-text>
            </v-row>
            <v-divider/>
            <v-row no-gutters justify="space-between" align-content="center" class="actions-container">
                <div class="v-card-actions-left-zone" @click.stop="triggerAnimation('shuffle-to-front')"></div>
                <div class="v-card-actions-right-zone" @click.stop="triggerAnimation('shuffle-to-back')"></div>

                <v-btn icon x-large :disabled="textCardIndex <= 0" @click.stop="triggerAnimation('shuffle-to-front')"><v-icon>mdi-chevron-left-circle</v-icon></v-btn>

                <v-menu v-model="textCardMenu" rounded="lg" offset-x right origin="center" transition="scale-transition" min-width="300" max-width="300" close-on-content-click style="overflow-y: scroll;">
                    <template v-slot:activator="{ on }">
                        <span v-on="on" style="cursor: pointer; font-weight: bold; border: 2px solid var(--v-accent-base); border-radius: 50%; width: 1.75rem; height: 1.75rem; display: inline-flex; align-self: center; align-items: center; justify-content: center;" :style="{ fontSize: subtitleIndex+1 >= 10 && subtitleIndex+1 < 100 ? '85%' : subtitleIndex+1 >= 100 && subtitleIndex+1 < 1000 ? '65%' : subtitleIndex+1 >= 1000 ? '25%' : '105%'}" class="accent--text" @click.stop="textCardMenu = !textCardMenu">{{ subtitleIndex + 1 }}</span>
                    </template>

                    <v-list v-if="textCardMenu" rounded style="max-height: 300px; overflow-y: scroll;">
                        <div v-for="(text, index) in textPost.textAdded" v-bind:key="index" style="justify-content: center; align-self: center;">
                            <v-list-item :key="index" style="cursor: pointer;" @click.stop="openTextCardMenu(index), textCardMenu = !textCardMenu">
                                <span style="font-weight: bold; border: 2px solid var(--v-accent-base); border-radius: 50%; width: 1.75rem; height: 1.75rem; display: inline-flex; align-self: center; align-items: center; justify-content: center;" :style="{ fontSize: index+1 >= 10 && index+1 < 100 ? '85%' : index+1 >= 100 && index+1 < 1000 ? '65%' : index+1 >= 1000 ? '25%' : '105%'}" class="mr-1 accent--text">{{ index+1 }}</span>
                                <v-list-item-icon class="mr-1"><v-icon v-if="hasCaptionForIndex(index + 1)">mdi-closed-caption-outline</v-icon></v-list-item-icon>
                                <v-list-item-content>
                                    <v-list-item-title @click.stop="openTextCardMenu(index), textCardMenu = !textCardMenu">{{ text }}</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider v-if="index < textPost.textAdded.length - 1" class="pt-2"/>
                        </div>
                    </v-list>
                </v-menu>

                <v-btn icon x-large :disabled="textCardIndex >= (textPost.textAdded.length - 1) || subtitleIndex + 1 >= (textPost.textAdded.length)" @click.stop="triggerAnimation('shuffle-to-back')"><v-icon>mdi-chevron-right-circle</v-icon></v-btn>
            </v-row>
        </div>

    </v-card>
</template>

<script>


export default {
    name: "TextIndexView",
    props: ["textPost", "currentAudioElementAudioData", "audioIsLoading", "audioIsPlaying", "selectedAudioId", "triggerAnimationAfterRecord", "changeAudioElementClicked", "changeAudioSegmentClicked"],
    data: function () {
        return {
            isShuffling: false,
            animationClass: '',

            direction: "",
            textCardIndex: 0,
            subtitleIndex: 0,

            textCardMenu: false,
            shuffleToFrontFromMenu: false,
            backTextCardIndex: 0,
            textCardMenuIndexValueSelected: null,
            fromTextCardMenu: false,

            loadAndPreloadValue: null, // 0 = previous, 1 = next, 2 = after click

            showCaptions: (this.$store.state.userData.showCaptions !== undefined && this.$store.state.userData.showCaptions !== null) ? this.$store.state.userData.showCaptions : true, // if showCaptions does not exist set to true. Only used in computed property of VideoPlayer.vue to show/hide captions
            captionVolume: this.$store.state.userData.captionAudio ? 1.0 : 0.0,
            playbackRate: 1.0,

            volumeMenu: false,
            playbackRateMenu: false,
            autoSkipDelay: false, // set to false during contribution creation so that auto skip is off and it doesn't skip/advance automatically
            autoSkipDelayTime: 0, // set to 0 during contribution creation so that auto skip is off and it doesn't skip/advance automatically
            autoSkipTimer: null,
            playNextAudioTimer: null,
        };
    },
    methods: {
        hasCaptionForIndex: function (cardIndex) {
            if (!this.currentAudioElementAudioData) return false;
            return (Array.isArray(this.currentAudioElementAudioData?.audioData?.text) && this.currentAudioElementAudioData.audioData.text.some(item => item.textCardIndexAssociationValue === cardIndex));
        },
        openTextCardMenu: function (indexValue) {
            if (indexValue == this.subtitleIndex) return;

            this.fromTextCardMenu = true;
            let animationType;
            this.textCardMenuIndexValueSelected = indexValue;
            (indexValue < this.subtitleIndex) ? (animationType = 'shuffle-to-front', (this.shuffleToFrontFromMenu = true, this.backTextCardIndex = this.textCardIndex), [this.subtitleIndex, this.textCardIndex] = [indexValue+1, indexValue+1]) : (animationType = 'shuffle-to-back', [this.subtitleIndex, this.textCardIndex] = [indexValue-1, indexValue-1], this.fromTextCardMenu = true);
            this.triggerAnimation(animationType);
        },
        changeTextCardIndex: function (direction, subtitleIndexValue) {
            if (direction == 'next' && ((this.textCardIndex + 1) <= (this.textPost.textAdded.length - 1))) {
                this.textCardIndex += 1;
                if (this.textCardIndex !== subtitleIndexValue) { // this will get called when a user presses the right chevron arrow multiple times before the next card can be loaded
                    this.textCardIndex = subtitleIndexValue;
                    this.loadAndPreloadValue = 2;
                    this.selectedAudioId && this.$emit("loadAndPreloadAudioData", this.loadAndPreloadValue, this.currentSubtitle, this.textCardIndex), this.$emit("textIndexChevronPressed", this.direction); // send textCardIndex to loadAndPreloadAudioData so it can load the correct AudioSegment from the selected AudioElement
                } else { // this will get called when a user presses the right chevron arrow only one time (next card gets loaded), or when a user selects a text card from the menu
                    if (this.fromTextCardMenu) { // user selected a text card from the menu, so we need to specifically tell loadAndPreloadAudioData to load data after a click
                        this.fromTextCardMenu = false;
                        this.loadAndPreloadValue = 2;
                        this.selectedAudioId && this.$emit("loadAndPreloadAudioData", this.loadAndPreloadValue, this.currentSubtitle, this.textCardIndex), this.$emit("textIndexChevronPressed", this.direction); // send textCardIndex to loadAndPreloadAudioData so it can load the correct AudioSegment from the selected AudioElement
                    } else { // user pressed either the right arrow chevron or right side of card, just ONE CLICK ONLY
                        this.loadAndPreloadValue = 1;
                        this.selectedAudioId && this.$emit("loadAndPreloadAudioData", this.loadAndPreloadValue, this.currentSubtitle/*, this.textCardIndex*/), this.$emit("textIndexChevronPressed", this.direction);
                    }
                }

                if (this.currentSubtitle && this.autoSkipDelay) {
                    this.playNextAudioTimer = setTimeout(() => {
                        this.$emit('playOrPauseAudioClicked', true);
                    }, 1000);
                } else if (this.autoSkipDelay && (this.textCardIndex + 1) <= (this.textPost.textAdded.length - 1)) {
                    this.handleAutoSkipTrigger();
                }

            }
            if (direction == 'previous' && ((this.textCardIndex - 1) >= 0)) {
                this.textCardIndex -= 1;
            }
        },
        triggerAnimation: function (animationType) { // Logic to update text index and trigger animation
            clearTimeout(this.autoSkipTimer);
            clearTimeout(this.playNextAudioTimer);

            const canShuffleToBack =
                ((animationType === 'shuffle-to-back') &&
                (this.subtitleIndex + 1 < this.textPost.textAdded.length));

            const canShuffleToFront =
                ((animationType === 'shuffle-to-front') &&
                (this.subtitleIndex > 0));

            if (!canShuffleToBack && !canShuffleToFront) return;

            this.isShuffling = true;

            if (this.audioIsPlaying) this.$emit('playOrPauseAudioClicked'/*, this.currentSubtitle, false*/);

            this.animationClass = animationType;
            this.direction = canShuffleToBack ? 'next' : 'previous';
            this.subtitleIndex += canShuffleToBack ? 1 : -1;

            if (canShuffleToFront) this.changeTextCardIndex(this.direction, this.subtitleIndex); // this will change the textCardIndex to minus 1, which will trigger the previous $emit in resetAnimation
        },
        resetAnimation: function () { // called when the shuffle animation is complete (i.e. when triggerAnimation ends)
            this.animationClass = ''; // reset animation class to empty string after animation ends
            if (this.direction === "next") { 
                this.changeTextCardIndex(this.direction, this.subtitleIndex);
            }
            if (this.direction === "previous") {
                this.shuffleToFrontFromMenu = false;
                this.loadAndPreloadValue = 0;
                this.selectedAudioId && this.$emit("loadAndPreloadAudioData", this.loadAndPreloadValue, this.currentSubtitle, this.textCardIndex), this.$emit("textIndexChevronPressed", this.direction);
            }
            this.isShuffling = false;
        },
        advancedControlsClick: function (advancedControl) {
            switch (advancedControl) {
                case 'playPauseReplay': // play, pause or replay video
                    clearTimeout(this.playNextAudioTimer);
                    clearTimeout(this.autoSkipTimer);
                    let resetHasBeenPlayed = this.currentSubtitle?.hasBeenPlayed ? true : false;
                    this.$emit('playOrPauseAudioClicked', resetHasBeenPlayed);
                    return;
                case 'captions':
                    this.showCaptions = !this.showCaptions;
                    return;
                case 'autoSkip':
                    clearTimeout(this.autoSkipTimer);
                    this.autoSkipDelay = !this.autoSkipDelay;
                    return;
                case 'volume':
                    this.volumeMenu = true;
                    return;
                case 'playbackRateMinus':
                    this.playbackRate = Math.max(this.playbackRate - 0.05, 0.25);
                    this.$emit('playbackRateChanged', this.playbackRate);
                    return;
                case 'playbackRatePlus':
                    this.playbackRate = Math.min(this.playbackRate + 0.05, 2);
                    this.$emit('playbackRateChanged', this.playbackRate);
                    return;
                default:
                    return;
            }
        },
        handleAutoSkipTrigger: function () {
            clearTimeout(this.autoSkipTimer);

            if (this.autoSkipDelay) {
                this.autoSkipTimer = setTimeout(() => {
                    this.triggerAnimation('shuffle-to-back');
                }, this.autoSkipDelayTime * 1000);
            }
        },
        // dynamicButtonSize: function () {
        //     if (this.$vuetify.breakpoint.lg || this.$vuetify.breakpoint.xl) {
        //         this.screenIsLargeOrBigger = true;
        //         this.screenIsMediumOrSmaller = false;
        //     } else {
        //         this.screenIsLargeOrBigger = false;
        //         this.screenIsMediumOrSmaller = true;
        //     }
        // },
    },
    watch: {
        'triggerAnimationAfterRecord': {
            handler: function(value){
                if (value) this.triggerAnimation('shuffle-to-back');
            }
        },
        changeAudioElementClicked: function (value) {
            // console.log("changeAudioElementClicked watcher triggered in TextIndexCardContainer.vue: ", value);
            if (value) {
                this.textCardIndex = 0;
                this.subtitleIndex = 0;
                this.backTextCardIndex = 0;
                this.$emit("resetChangeAudioElementClicked");
            };
        },
        changeAudioSegmentClicked: function (value) {
            if (value) {
                this.textCardIndex = value.textCardIndexAssociationValue - 1;
                this.subtitleIndex = value.textCardIndexAssociationValue - 1;
                this.backTextCardIndex = (value.textCardIndexAssociationValue - 2 < 0) ? 0 : value.textCardIndexAssociationValue - 2;
                this.$emit("resetChangeAudioSegmentClicked");
            }
        }
    },
    computed: {
        currentSubtitle () {
            // if (!this.currentAudioElementAudioData) return null;
            return this.currentAudioElementAudioData?.audioData.text.find(item => item.textCardIndexAssociationValue === this.subtitleIndex + 1);
        },
        dynamicVCardHeight () {
            if (this.$vuetify.breakpoint.xl) {
                // console.log("XL");
                return "40vh"
            } else if (this.$vuetify.breakpoint.lg) {
                // console.log("LG");
                return "55vh"
            } else if (this.$vuetify.breakpoint.md) {
                // console.log("MD");
                return "50vh"
            } else if (this.$vuetify.breakpoint.sm) {
                // console.log("SM");
                return "60vh"
            } else {
                // console.log("XS");
                return "60vh"
            }
        },
        dynamicIndexCardWidthHeight () {
            // console.log("width: ", this.$vuetify.breakpoint.width);
            if (this.$vuetify.breakpoint.xl) {
                // console.log("XL");
                return {width: '45%', height: '80%'}
                // return {width: '65%', height: '75%'}
            } else if (this.$vuetify.breakpoint.lg) {
                // console.log("LG");
                return {width: '55%', height: '75%'}
            } else if (this.$vuetify.breakpoint.md) {
                // console.log("MD");
                return {width: '65%', height: '60%'}
            } else if (this.$vuetify.breakpoint.sm) {
                // console.log("SM");
                return {width: '65%', height: '60%'}
            } else {
                // console.log("XS");
                return {width: '100%', height: '90%'}
            }
        },
        // dynamicIndexCardWidthHeight(){
        //     if (this.$vuetify.breakpoint.xl) {
        //         // console.log("XL");
        //         return {width: '45%', height: '80%'}
        //     } else if (this.$vuetify.breakpoint.lg) {
        //         // console.log("LG");
        //         return {width: '50%', height: '80%'}
        //     } else if (this.$vuetify.breakpoint.md) {
        //         // console.log("MD");
        //         return {width: '55%', height: '55%'}
        //     } else if (this.$vuetify.breakpoint.sm) {
        //         // console.log("SM");
        //         return {width: '60%', height: '55%'}
        //     } else {
        //         // console.log("XS");
        //         return {width: '100%', height: '95%'}
        //     }
        // },
        dynamicFontSizeFrontCard() {
            const text = this.textPost.textAdded[this.textCardIndex] || '';
            const length = text.length;

            let fontSize = '1.75rem'; // default

            if (length > 120) {
                fontSize = '1.25rem';
            } else if (length > 90) {
                fontSize = '1.5rem';
            } else if (length > 60) {
                fontSize = '1.75rem';
            } else if (length > 30) {
                fontSize = '2rem';
            } else {
                fontSize = '2.25rem';
            }

            return {
                fontSize,
                height: '100%',
                lineHeight: 1.25,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
            };
        },
        dynamicFontSizeBackCard() {
            const text = (this.shuffleToFrontFromMenu ? this.textPost.textAdded[this.backTextCardIndex] : this.textPost.textAdded[this.textCardIndex+1]) || '';
            const length = text.length;

            let fontSize = '1.75rem'; // default

            if (length > 120) {
                fontSize = '1.25rem';
            } else if (length > 90) {
                fontSize = '1.5rem';
            } else if (length > 60) {
                fontSize = '1.75rem';
            } else if (length > 30) {
                fontSize = '2rem';
            } else {
                fontSize = '2.25rem';
            }

            return {
                fontSize,
                height: '100%',
                lineHeight: 1.25,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
            };
        },
        dynamicFontSizeCurrentSubtitle() {
            const text = this.textPost.textAdded[this.textCardIndex] || '';
            const length = text.length;

            let fontSize = '1.25rem'; // default

            if (length > 120) {
                if (this.$vuetify.breakpoint.xl) {
                    fontSize = '1.25rem';
                } else {
                    fontSize = '1.15rem';
                }
            } else if (length > 90) {
                fontSize = '1.35rem';
            } else if (length > 60) {
                fontSize = '1.55rem';
            } else if (length > 30) {
                fontSize = '1.65rem';
            } else {
                fontSize = '2.25rem';
            }

            return {
                fontSize,
                overflowWrap: 'break-word',
                wordWrap: 'break-word',
                wordBreak: 'break-word',
            };
        },
        dynamicHeightCaptionCard () {
            const text = this.textPost.textAdded[this.textCardIndex] || '';
            const length = text.length;

            let height = '20%';

            if (length > 120) {
                height = '18%';
            } else if (length > 90) {
                height = '19%';
            } else if (length > 60) {
                height = '20%';
            } else if (length > 30) {
                height = '21%';
            } else {
                height = '22%';
            }

            return {
                alignSelf: 'flex-end',
                alignContent: 'center',
                width: '80%',
                height,
            }
        },
    },
    mounted: function () {
        // window.addEventListener('resize', this.dynamicButtonSize);
    },
    created: function() {
        // console.log("this.selectedAudioId", this.selectedAudioId);
        // this.dynamicButtonSize();
    },
    beforeDestroy: function() {
        // window.removeEventListener('resize', this.dynamicButtonSize);
        clearTimeout(this.autoSkipTimer);
    },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .index-card-container {
    position: relative;
    width: 100%;
    height: 50% !important;
    justify-content: center;
    align-content: center;
  }

  .index-card {
    position: absolute;
    font-size: 1.5rem;
    align-self: start !important;
  }

  .v-card-title {
    font-size: 1.5rem !important;
    padding: 0 12px;
  }

  .play-pause-button-container {
    position: relative;
    align-items: center !important;
    height: 12% !important;
  }

  .captions-container {
    height: 26% !important;
  }

  .actions-container {
    height: 12% !important;
    flex-wrap: nowrap;
  }
}


.left-zone,
.right-zone {
    position: absolute;
    top: 0;
    width: 50%; /* Half of the card width */
    height: 100%; /* of the card height */
    z-index: 1; /* Ensure it's above the content */
}
.left-zone {
    left: 0;
    cursor: pointer;
}
.right-zone {
    right: 0;
    cursor: pointer;
}

.v-card-container {
    position: absolute;
    width: 100%;
    height: 100%;
    perspective: 1000px;
}

.index-card-container {
    position: relative;
    width: 100%;
    height: 60%;
    justify-content: center;
    align-content: center;
}

.index-card {
    position: absolute;
    align-self: center;
    border-radius: 12px;
    box-shadow: 2px 4px 10px rgba(0, 0, 0, 0.2);
    border: 1px solid #ccc;

    background: repeating-linear-gradient(
        to bottom,
        white 0px,
        white 20px,
        #cce7ff 21px
    );
}

.index-card::before { /* Simulating red horizontal line on index card */
    content: "";
    position: absolute;
    top: 1.50rem;
    left: 0;
    width: 100%;
    height: 2px;
    background: #ff0000;
    z-index: 1;
}

/* Front Side */
.front-card {
    z-index: 2;
}

/* Back Side */
.back-card {
    z-index: 1;
}

.shuffle {
    animation: shuffleCard 0.75s ease-in-out;
}

/* .shuffle-to-back {
    animation: shuffleCard 0.8s ease-in-out;
}
.shuffle-to-front {
    animation: shuffleCardReverse 0.8s ease-in-out;
} */
.shuffle-to-back {
    animation: shuffleCard 1.0s ease-in;
}
.shuffle-to-front {
    animation: shuffleCardReverse 0.8s ease-in;
}

@keyframes shuffleCard {
    0% {
        transform: scale(1) translateY(0) rotate(0deg);
        opacity: 1;
        z-index: 10;
    }
    25% {
        transform: scale(0.50) translateY(-125%) translateX(120%) rotate(30deg);
        opacity: 0.50;
    }
    50% {
        transform: scale(0.25) translateY(-200%) translateX(200%) rotate(45deg);
        opacity: 0.25;
    }
    75% {
        transform: scale(0.1) translateY(-250%) translateX(250%) rotate(30deg);
        opacity: 0.00;
    }
    100% {
        transform: scale(0.0) translateY(0) rotate(0deg);
        opacity: 0;
    }
}
@keyframes shuffleCardReverse {
    0% {
        transform: scale(0.0) translateY(0) rotate(0deg);
        opacity: 0;
    }
    25% {
        transform: scale(0.1) translateY(-250%) translateX(250%) rotate(30deg);
        opacity: 0.00;
    }
    50% {
        transform: scale(0.25) translateY(-200%) translateX(200%) rotate(45deg);
        opacity: 0.25;
    }
    75% {
        transform: scale(0.50) translateY(-125%) translateX(120%) rotate(30deg);
        opacity: 0.50;
    }
    100% {
        transform: scale(1) translateY(0) rotate(0deg);
        opacity: 1;
        z-index: 10;
    }
}

.play-pause-button-container {
    position: relative;
    justify-content: center;
    align-self: center;
    width: 100%;
    height: 10%;
}

.play-pause-button {
    position: relative;
}

.captions-container {
    position: relative;
    justify-self: center;
    align-content: center;
    width: 85%;
    height: 20%;
}

.v-card-captions {
    align-self: flex-end;
    align-content: center;
    width: 80%;
    height: 20%;
}

.actions-container {
    position: relative;
    width: 100%;
    height: 10%;
}

.v-card-actions {
    align-items: center;
    justify-content: space-between;
}

.v-card-actions-left-zone,
.v-card-actions-right-zone {
    position: absolute;
    bottom: 0;
    width: 45%; /* Half of the card width */
    height: 100%; /* of the card height */
    z-index: 1; /* Ensure it's above the content */
}
.v-card-actions-left-zone {
    left: 0;
    cursor: pointer;
}
.v-card-actions-right-zone {
    right: 0;
    cursor: pointer;
}
</style>